import { Injectable, inject } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { NetworkService } from '../../shared/services/network.service';
import { AuthStore } from '../../store/auth.store';

/**
 * `/ruta-del-dia`: solo sin conexión y con snapshot de sesión de campo válido.
 * Con conexión redirige a Inicio (la entrada no está en el menú online).
 */
@Injectable({
  providedIn: 'root'
})
export class RutaDelDiaGuard implements CanActivate {
  private readonly network = inject(NetworkService);
  private readonly authStore = inject(AuthStore);
  private readonly router = inject(Router);

  canActivate(): boolean {
    if (this.network.isOnline()) {
      void this.router.navigate(['/inicio'], { replaceUrl: true });
      return false;
    }
    if (!this.authStore.puedeUsarRutaDelDiaOffline()) {
      void this.router.navigate(['/login']);
      return false;
    }
    return true;
  }
}
